import React from 'react';
import { api_route, user_logout } from '../helpers/Global';
import { withRouter } from 'react-router-dom';
import ColisAction from './ColisPartials/ColisAction';
import ColisJornal from './ColisPartials/ColisJornal';
import queryString from 'query-string';

class Colis extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            colis: [],
            coli_action: '',
            coli_btn_action: false,
            selected_coli: null,
            colis_title: '',
            statut: props.statut,
            statut_shipped: null,
            refresh_data: 'init',
            count_colis: 0,
            page: 1,
            btn_loading_text: '',
            time_param: '',
            scrolling: true,
            coli_journal: false,
            current_page: ''
        }
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        var params = queryString.parse(this.props.location.search);
        var time_param = params.t;

        if (this.state.time_param !== time_param || this.state.refresh_data) {

            var page = this.state.page;
            var init_list = false;
            if (this.state.time_param !== time_param || this.state.refresh_data === 'init') {
                this.setState({ page: 1 });
                init_list = true;
                page = 1;
            }

            if (init_list && params.loader !== 'false') {
                this.props.loaderDisplay(true);
            }

            var statut = this.props.statut;
            var keyword = params.keyword;
            var fixedkeyword = params.fixedkeyword;
            
            if(fixedkeyword){
                keyword = fixedkeyword;
            }
            
            let url_params = '';
                
            if (statut === 'list') {
                if (params.statut_alert) {
                    this.setState({
                        colis_title: params.title,
                        coli_btn_action: true
                    });
                    url_params = '&page=' + page + '&statut_alert=' + params.statut_alert;
                } else if (keyword) {
                    if(!fixedkeyword){
                        this.setState({
                            colis_title: 'Résultat de votre recherche "' + keyword + '"',
                            coli_btn_action: true
                        }); 
                    }else{
                        this.setState({
                            coli_btn_action: true
                        }); 
                    }
                    
                    url_params = '&page=' + page + '&keyword=' + keyword;
                    
                    if(params.readmessage == 1){
                        /*
                            Read Messages
                        */
                        
                        let formData = new FormData();
                        formData.append('barecode', keyword);
                        fetch(api_route('read-messages-colis'), { method: 'POST', body: formData })
                        .then(resp => resp.json())
                        .then(resp => {
                            if (resp.response === 'error-connected') {
                                user_logout();
                                this.props.history.push(`/user-logout`);
                                this.props.loaderDisplay(false);
                            }
                        })
                        .catch(err => {
                            //this.props.history.push(`/user-logout`);
                            //this.props.loaderDisplay(false);
                            //console.log(err);

                            this.props.loaderDisplay(false);
                            this.props.openErrorSystem(true);
                        })
                    }
                }else if (params.typeredirect == "proche") {
                    this.setState({
                        colis_title: 'Liste des colis proches de la livraison',
                        coli_btn_action: true
                    });
                    url_params = '&page=' + page + '&typeredirect=' + params.typeredirect;
                    console.log(url_params);
                }

            } else {

                var statut_shipped = params.statut_shipped;
                if (statut === 'shipped') {
                    var statut_shipped_text = 'En cours de livraison';
                    if (statut_shipped === 'without_motif') {
                        statut_shipped_text = 'Les colis sans appels';
                    } else if (statut_shipped === 'shipped_injoignable') {
                        statut_shipped_text = 'Les colis injoignable';
                    } else if (statut_shipped === 'shipped_reported') {
                        statut_shipped_text = 'Les colis reporté';
                    } else if (statut_shipped === 'shipped_refused') {
                        statut_shipped_text = 'Les colis refusé par le client';
                    }
                    this.setState({
                        colis_title: (statut_shipped_text),
                        coli_btn_action: true
                    });
                } else if (statut === 'delivered') {
                    this.setState({
                        colis_title: 'Colis livrés',
                        coli_btn_action: false
                    });
                } else if (statut === 'undelivered') {
                    this.setState({
                        colis_title: 'Mes retours',
                        coli_btn_action: false
                    });
                }

                url_params = '&page=' + page + '&statut=' + statut;
                if (statut_shipped) {
                    url_params = url_params + '&statut_shipped=' + statut_shipped;
                }

            }
            
            fetch(api_route('liste-colis') + url_params, { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                        this.props.loaderDisplay(false);
                    } else if (resp['liste-colis']) {

                        var count_colis = resp['total-colis'];
                        this.setState({
                            colis: (init_list ? resp['liste-colis'] : this.state.colis.concat(resp['liste-colis'])),
                            count_colis: count_colis
                        }, function () {

                            this.setState({
                               // btn_loading_text: (this.state.colis.length !== count_colis ? 'Afficher plus' : null),
                            }, function () {
                                if (this.state.btn_loading_text && document.getElementById('btnLoadMore')) {
                                    document.getElementById('btnLoadMore').classList.remove('disabled');
                                }

                                if (resp['info-general']) {
                                    this.props.setLivreur(resp['info-general']);
                                }
                            });

                            this.props.loaderDisplay(false);
                        });
                    }else{
                        this.props.loaderDisplay(false);
                    }
                })
                .catch(err => {
                    //this.props.history.push(`/user-logout`);
                    //this.props.loaderDisplay(false);
                    //console.log(err);

                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })

            this.setState({
                statut: this.props.statut,
                statut_shipped: statut_shipped,
                time_param: time_param,
                coli_action: '',
                refresh_data: false,
                scrolling: true,
                coli_journal: false,
            });

        }

        // back button 
        if (this.state.current_page !== this.props.current_page) {
            var coli_action = this.state.coli_action;
            var coli_journal = this.state.coli_journal;
            if (this.props.current_page === 'list_colis') {
                coli_action = '';
                coli_journal = false;
            }
            this.setState({
                current_page: this.props.current_page,
                coli_action: coli_action,
                coli_journal: coli_journal
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        /*if (this.state.scrolling) {
            const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
            const body = document.body;
            const html = document.documentElement;

            const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            const windowBottom = windowHeight + window.pageYOffset;
            if (windowBottom >= docHeight) {
                this.loadMore();
            }
        }*/
    }

    render() {
        
        if (this.state.coli_journal) {
            return (
                <ColisJornal
                    selected_coli={this.state.selected_coli}
                    setCurrentPage={this.props.setCurrentPage}
                    current_page={this.props.current_page}
                    coli_btn_action={this.state.coli_btn_action}
                    coliActions={this.coliActions}
                    openConfirmModal={this.openConfirmModal}
                    coli_action={this.state.coli_action}
                    initColiAction={this.initColiAction}
                    loaderDisplay={this.props.loaderDisplay}
                    openErrorSystem={this.props.openErrorSystem}

                />
            );
        }

        if (this.state.coli_action) {
            return (
                <ColisAction
                    loaderDisplay={this.props.loaderDisplay}
                    coli={this.state.selected_coli}
                    coli_action={this.state.coli_action}
                    initColiAction={this.initColiAction}
                    setCurrentPage={this.props.setCurrentPage}
                    current_page={this.props.current_page}
                    openErrorSystem={this.props.openErrorSystem}

                />
            );
        }

        const statut_color = this.state.statut === 'delivered' ? 'text-success' : (this.state.statut === 'undelivered' ? 'text-danger' : 'text-warning');
        
        var today = new Date();
        var now_time = today.getHours() + ":" + today.getMinutes();
        
        var liste_colis_cats = [];
        if(this.state.colis && this.state.colis['shipped_refused']){
            liste_colis_cats = this.state.colis['shipped_refused']['liste_colis'];
        }
        
        
        var liste_cats_colis = Object.keys(this.state.colis);
        /*liste_cats_colis.forEach(function(element,keyelemnt){
            var liste_colis_cat =   this.state.colis["shipped_refused"];
            console.log(liste_colis_cat);
        
        });*/

        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity" style={{ height: 'auto' }}>
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">{this.state.colis_title}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="container">
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-header">
                                <h6>Liste des colis</h6>
                            </div>
                            <div className="card-body">
                                {liste_cats_colis.map((elementcats, indicecats) =>
                                    
                                <table className="table table-bordered table-striped listeorders"  style={{ 'marginBottom': '60px' }}>
                                    <thead>
                                        <tr>
                                            <th>
                                                {this.state.colis[elementcats]['name_slugan'] && (
                                                    <React.Fragment>  
                                                        {this.state.colis[elementcats]['name_slugan']} ( {this.state.colis[elementcats]['total_colis']} colis )
                                                    </React.Fragment>
                                                )}
                                                
                                                {!this.state.colis[elementcats]['name_slugan'] && (
                                                    <React.Fragment>{this.state.colis[elementcats]['total_colis']} colis
                                                    </React.Fragment>
                                                )}
                                                            
                                                
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.colis[elementcats]['liste_colis'].map((coli, indice) =>
                                            <React.Fragment key={indice + coli.barecode}>
                                                <tr className="show-info-colis" onClick={() => this.openDetails(indice + coli.barecode)}>
                                                    <td className="footable-first-visible p-relative">
                                                        <span
                                                            className="footable-toggle fooicon fooicon-plus"
                                                            id={`fooicon${indice + coli.barecode}`}>
                                                        </span>
                                                        <div className="icons icon-30 p-0 mr-2 vm icon-circle align-self-start bg-danger text-white">
                                                            {coli.recipient_name.charAt(0)}
                                                        </div>
                                                        <h6 className="d-inline-block vm" style={{ 'lineHeight': '22px', 'width': '90%', 'float': 'right' }}>
                                                            <span>{coli.barecode}</span><br />

                                                            {coli.lastcall && (
                                                                <React.Fragment>  
                                                                     <span className='text-success' style={{ 'fontSize': '14px' }}><small>{coli.lastcall}</small></span><br />
                                                                </React.Fragment>
                                                            )}
                                                            
                                                            <strong className='text-primary' style={{ 'fontSize': '14px' }}>
                                                                {React.createElement('b', { dangerouslySetInnerHTML: { __html: coli.min_statut } })}
                                                            </strong><br /><br />

                                                            <span className="font-weight-normal"><i className="material-icons ml-0 md-18">qr_code</i>
                                                                {coli.tracking_number}
                                                            </span><br />

                                                            <span className="font-weight-normal"><i className="material-icons ml-0 md-18">person</i>
                                                                {coli.recipient_name}
                                                            </span><br />

                                                            <span className="font-weight-normal"><i className="material-icons ml-0 md-18">phone</i>
                                                                {coli.recipient_phone}
                                                            </span><br />

                                                            <span className="font-weight-normal"><i className="material-icons ml-0 md-18">attach_money</i>
                                                                {coli.price}
                                                            </span><br />

                                                            <span className="font-weight-normal"><i className="material-icons ml-0 md-18">location_on</i>
                                                                {coli.recipient_address}
                                                            </span>
                                                        </h6>

                                                        {this.state.coli_btn_action && coli.key_statut == "shipped" && (
                                                            <React.Fragment>  
                                                                <a onClick={() => this.coliActions(coli, 'call')}>
                                                                    <span className="btn-tcall fhide" style={{ 'fontWeight': 'normal' }}> <i style={{ 'marginLeft': '0 !important'}} className="material-icons md-18 ml-1">call</i></span>
                                                                </a>
                                                            </React.Fragment>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr id={`tr_${indice + coli.barecode}`} className="footable-detail-row d-none">
                                                    <td>
                                                        <table className="footable-details table table-bordered table-striped">
                                                            <tbody>
                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                    <th>Num</th>
                                                                    <td>
                                                                        {React.createElement('b', { dangerouslySetInnerHTML: { __html: coli.str_barecode } })}
                                                                         {coli.tracking_number && (
                                                                            <React.Fragment>  
                                                                                <br /><span className='text-danger' style={{ 'fontSize': '14px' }}><small>{coli.tracking_number}</small></span><br />
                                                                            </React.Fragment>
                                                                        )}  
                                                                    </td> 
                                                                </tr>
                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                    <th>Statut</th>
                                                                    <td>
                                                                        <span className={statut_color}>
                                                                            {React.createElement('b', { dangerouslySetInnerHTML: { __html: coli.statut } })}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                    <th>Nom complet</th>
                                                                    <td>{coli.recipient_name}</td>
                                                                </tr>
                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                    <th>Ville</th>
                                                                    <td>{coli.recipient_city}</td>
                                                                </tr>
                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                    <th>Adresse</th>
                                                                    <td>{coli.recipient_address}</td>
                                                                </tr>

                                                                {coli.seller_type != "e_commerce" && (
                                                                    <React.Fragment>                                           
                                                                        <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                            <th>Poids</th>
                                                                            <td >{coli.poids} Kg</td>
                                                                        </tr>

                                                                        <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                            <th>Nombre de colis</th>
                                                                            <td >{coli.number_shipments}</td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                )}
                                                                
                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis">
                                                                    <th>Prix</th>
                                                                    <td >{coli.price}</td>
                                                                </tr>

                                                                <tr onClick={() => this.showColisJournal(true, coli)} className="show-info-colis fhide">
                                                                    <th>Commentaire</th>
                                                                    <td >{coli.comment_seller}</td>
                                                                </tr>
    
                                                                {this.state.coli_btn_action && coli.key_statut == "shipped" && (
                                                                    <React.Fragment>                                           
                                                                        <tr className="show-info-colis">
                                                                            <td colSpan="2" className="hide-d" style={{ 'paddingLeft': '5px' }}>
                                                                                <button type="button" className="btn-lcolis buynow btn btn-warning text-uppercase" onClick={() => this.coliActions(coli, 'call')}>Appeler <i className="material-icons md-18 ml-1">call</i></button>
                                                                                <button className="btn-lcolis buynow btn btn-success text-uppercase" onClick={() => this.openConfirmModal(true, coli)}>Livrer <i className="material-icons md-18 ml-1">check</i></button>
                                                                                <button type="button" className="btn-lcolis buynow btn btn-danger text-uppercase" onClick={() => this.coliActions(coli, 'echec')}>Échec <i className="material-icons md-18 ml-1">error_outline</i></button>
                                                                            </td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )}

                                    </tbody>
                                </table>
                                )}

                                {this.state.btn_loading_text && (
                                    <button type="button" id="btnLoadMore" className="btn btn-light btn-block" onClick={() => this.loadMore()}>{this.state.btn_loading_text}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );


    }

    showColisJournal = (v, coli) => {
        this.setState({
            selected_coli: coli,
            coli_journal: v,
            scrolling: false
        });
    }

    loadMore = () => {
        if (this.state.btn_loading_text) {
            const page = this.state.page + 1
            this.setState({
                page: page,
                refresh_data: true,
                btn_loading_text: 'Loading...'
            }, function () {
                var btn = document.getElementById('btnLoadMore');
                if (btn) btn.classList.add('disabled');
            });
        }
    }

    coliActions = (coli, action) => {
        coli.listing_statut = this.state.statut;
        coli.listing_statut_shipped = this.state.statut_shipped || null;
        this.setState({
            scrolling: false,
            coli_action: action,
            selected_coli: coli,
        });
    }

    initColiAction = () => {
        this.setState({
            coli_action: ''
        });
    }


    openConfirmModal = (v, coli = null) => {
        this.props.showModal('colis_livrer', coli)
    }

    openDetails = (id) => {
        var span = document.getElementById('fooicon' + id)
        var tr = document.getElementById('tr_' + id);
        if (tr.classList.contains('d-none')) {
            tr.classList.remove('d-none');
            span.classList.add('fooicon-minus');
            span.classList.remove('fooicon-plus');
        } else {
            tr.classList.add('d-none');
            span.classList.remove('fooicon-minus');
            span.classList.add('fooicon-plus');
        }
    }

    refreshList = (v = true) => {
        this.setState({ refresh_data: v });
    }

}

export default withRouter(Colis);